import { TerminologyState } from "../rootReducerTypes";
import { UpdateTerminologiesAction, UPDATE_TERMINOLOGIES, TerminologiesActionTypes } from "../reducersAndActionsType/terminologiesActionAndReducerTypes";

//#region actions
export function updateTerminologies(terminologies: any): UpdateTerminologiesAction {
  return {
      type: UPDATE_TERMINOLOGIES,
      terminologies: terminologies,
  };
}

export default function terminologiesReducer(state: TerminologyState = initialState, action: TerminologiesActionTypes): TerminologyState {
  switch (action.type) {
      case UPDATE_TERMINOLOGIES:
          return {
              ...state,
              terminologies: action.terminologies
          };
      default:
          return state;
  }
}

export const initialState: TerminologyState = {
  terminologies: undefined
};